import { EuroValue } from '@dokucoach/common-types';
import { CareLevel } from '@dokucoach/invoicing-types';
import { object } from 'yup';

export type ICostForCareLevels = { [key in CareLevel]: number };

export type ICostForCareLevelsCreate = { [key in CareLevel]: number };

export const ICostForCareLevelsCreateSchema = object({
  [CareLevel.NONE]: EuroValue.required(),
  [CareLevel.ONE]: EuroValue.required(),
  [CareLevel.TWO]: EuroValue.required(),
  [CareLevel.THREE]: EuroValue.required(),
  [CareLevel.FOUR]: EuroValue.required(),
  [CareLevel.FIVE]: EuroValue.required(),
});
